<template>
    <div v-if="isreadshow">
        <el-button type="text" @click="selecttbdwtotal('total')" v-if="errormsg===''">
            查看以下所有步骤的总分
        </el-button>
        <my-table :data="tableData" :height="tableHeight" v-if="errormsg===''">
            <el-table-column label="报价得分步骤" prop="name" min-width="220" fixed></el-table-column>
            <el-table-column label="操作" width="200px" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" @click="selecttbdw('node',scope.row.basepriceKey,scope.row.offerscoreKey,scope.row.mxnodekey,scope.row.name)">选择</el-button>
                </template>
            </el-table-column>
        </my-table>
        <!-- 报错页面 -->
        <errormsg :errormsg="errormsg" v-if="errormsg!==''"></errormsg>
    </div>
</template>

<script>
import errormsg from './errormsg'

import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],
    data() {
        return{
            errormsg:'',
            pgData:{
                txtkey:'',
                sortname : 'zbprocode',
                
            },
            isreadshow:true,
            tableData:[]
        }
    },
    components:{
        errormsg,
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        reload:function(){
            var that = this;
            this.isreadshow=false;
            this.$nextTick(function(){
                that.isreadshow=true;
            })
        },
        //选择
        selecttbdw:function(type,basepriceKey,offerscoreKey,mxnodekey,name){
            this.goto({
                path:'./selecttbdw',
                query:{
                    bdcode:this.$route.query.bdcode,
                    procode:this.$route.query.procode,
                    type:type,
                    basepriceKey:basepriceKey,
                    offerscoreKey:offerscoreKey,
                    mxnodekey:mxnodekey,
                    name:escape(escape(name))
                }
            });
        },
        // 查看以下所有步骤的总分
        selecttbdwtotal:function(type){
            this.goto({
                path:'./selecttbdw',
                query:{
                    bdcode:this.$route.query.bdcode,
                    procode:this.$route.query.procode,
                    type:type
                }
            })
        },
        getlist:function(){
            var that = this
            that.$get(`${this.getGetters('bidUrl')}/KaiBiao/getoffer/selectnode.json`,{bdcode:this.$route.query.bdcode,procode:this.$route.query.procode}, (data, res) => {
                if(data.errorCode=='error'){
                    that.errormsg=data.msg
                }else{
                    this.tableData = JSON.parse(data.nodelist)
                }
            });
        }

    },
    created() {
        this.getlist()
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

</style>
